import { lazy, Suspense } from "react";
import CabifyBanner from "../cabifyClone/CabifyBanner";
import BlinkitBuild from "../blinkit/BlinkitBuild";

const BlinkitElearning = lazy(() => import("../blinkit/BlinkitElearning"));
const BlinkitFeature = lazy(() => import("../blinkit/BlinkitFeature"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BlinkitApproach = lazy(() => import("../blinkit/BlinkitApproach"));
const BlinkitMarket = lazy(() => import("../blinkit/BlinkitMarket"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const BlaBlaAction = lazy(() => import("../blabla/BlaBlaAction"));


const bannerData = {
  title: "Grocery Platform Like Bigbasket",
  description: "Empower your business with Mobility Infotech’s robust on-demand grocery delivery app designed for convenience, trust, and scalability.",
  image: "/assets/home/blinkit-banner-front.webp",
  btn: "Get Started Now",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "bigbasket Clone App",
        slug: ""
      },
    ]
  }
};

const blinkBuildData = {
  titlePart1: "Build & Scale",
  titlePart2: "Your Grocery App Seamlessly",
  description: "Take your grocery delivery business from idea to impact with Mobility Infotech. Our tailored solutions, scalable architecture, and expertise help you launch fast, grow steadily, and stay ahead—even during market shifts.",
  boxes: [
    {
      desc: "Custom features designed for your goals",
      cta: "explore our workflow",
      image: "/assets/home/blink-build-1.webp"
    },
    {
      desc: "Scalable architecture for long-term growth",
      cta: "explore our workflow",
      image: "/assets/home/blink-build-2.webp"
    },
    {
      desc: "Bigbasket-inspired workflow",
      cta: "explore our workflow",
      image: "/assets/home/blink-build-3.webp"
    },
    {
      desc: "Business continuity, even in slowdowns or crises",
      cta: "explore our workflow",
      image: "/assets/home/blink-build-4.webp"
    }
  ]
}

const featureData = {
  title: "High-End Features for Your Bigbasket-Like App",
  description: "At Mobility Infotech, we pack our grocery delivery solutions with advanced, user-focused features for customers, vendors, delivery partners, and administrators — ensuring seamless ordering, real-time tracking, secure payments, and efficient deliveries.",
  features: [
    {
      name: "CUSTOMER APP",
      image: "/assets/home/blinkit-feature-1.webp",
      boxes: [
        {
          text: "Secure Login",
          desc: "OTP, biometrics, or password-based login",
          icon: "/assets/home/blinkit-feature-icon-1.webp"
        },
        {
          text: "Smart Search & Booking",
          desc: "Advanced filters, voice search, and intuitive booking for fast product discovery.",
          icon: "/assets/home/blinkit-feature-icon-2.webp"
        },
        {
          text: "Live Order Tracking",
          desc: "Real-time maps, and delivery status updates.",
          icon: "/assets/home/blinkit-feature-icon-3.webp"
        },
        {
          text: "Alerts & Payments",
          desc: "Instant order notifications and secure payment options.",
          icon: "/assets/home/blinkit-feature-icon-4.webp"
        },
      ]

    },
    {
      name: "ADMIN DASHBOARD",
      image: "/assets/home/blinkit-feature-3.webp",
      boxes: [
        {
          text: "Manage Everything in One Place",
          desc: "Effortlessly handle orders, inventory, payments, deliveries, and customer service from one powerful, centralized dashboard — designed to keep your business running smoothly and efficiently.",
          icon: "/assets/home/blinkit-feature-icon-5.webp"
        },
        {
          text: "Payments & Commissions",
          desc: "Simplify vendor payments, automate commission calculations, and monitor earnings in real-time with a secure, all-in-one financial management system.",
          icon: "/assets/home/blinkit-feature-icon-6.webp"
        },
        {
          text: "Monitor Deliveries",
          desc: "Stay on top of every delivery with live tracking, smart order assignments, and detailed performance insights — ensuring faster, more reliable service.",
          icon: "/assets/home/blinkit-feature-icon-7.webp"
        },
        {
          text: "Business Analytics",
          desc: "Unlock valuable insights into sales trends, customer behavior, and operational performance with advanced analytics to fuel smarter decisions and sustainable growth.",
          icon: "/assets/home/blinkit-feature-icon-8.webp"
        },
      ]

    },
    {
      name: "DRIVER APP",
      image: "/assets/home/blinkit-feature-2.webp",
      boxes: [
        {
          text: "Easy Onboarding",
          desc: "Enable drivers to join in minutes with a fast, hassle-free registration process, instant document verification, and quick start — no delays, no complications.",
          icon: "/assets/home/blinkit-feature-icon-9.webp"
        },
        {
          text: "Route Optimization",
          desc: "Cut delivery time, avoid traffic, save fuel, and boost efficiency with intelligent route planning for every order.",
          icon: "/assets/home/blinkit-feature-icon-10.webp"
        },
        {
          text: "Proof of Delivery",
          desc: "Build trust with customers through secure proof of delivery — complete with digital signatures or photos for full transparency and accountability.",
          icon: "/assets/home/blinkit-feature-icon-11.webp"
        },
        {
          text: "Daily Earnings Reports",
          desc: "Give drivers clear, real-time summaries of their daily income, completed orders, and bonuses — so they always know exactly what they’ve earned.",
          icon: "/assets/home/blinkit-feature-icon-12.webp"
        },
      ]

    },
    {
      name: "vENDoR PANEL",
      image: "/assets/home/blinkit-feature-4.webp",
      boxes: [
        {
          text: "Instant Updates",
          desc: "Keep your team and customers informed with live updates on orders, inventory, and delivery status — ensuring smooth operations and happy clients.",
          icon: "/assets/home/blinkit-feature-icon-13.webp"
        },
        {
          text: "Order Dashboard",
          desc: "Access all order details in one organized dashboard, making it easy to track, manage, and fulfill orders quickly.",
          icon: "/assets/home/blinkit-feature-icon-14.webp"
        },
        {
          text: "Business Reports",
          desc: "Generate detailed business reports to evaluate performance, identify opportunities, and plan for the future with confidence.",
          icon: "/assets/home/blinkit-feature-icon-15.webp"
        },
        {
          text: "Manage Menu & Offers",
          desc: "Update menus, launch new offers, and make changes instantly — keeping your products and promotions fresh and exciting.",
          icon: "/assets/home/blinkit-feature-icon-16.webp"
        },
      ]

    },
  ]
}

const actionData = {
  imageBack: "/assets/home/blinkit-action-back.webp",
  title: "Stay Ahead in the On-Demand Game",
  description: "Partner with Mobility Infotech to build scalable, future-ready grocery delivery apps that capture market trends and fuel business growth from day one.",
  btn: "Launch My App"
}

const elearningData = {
  titlePart1: "Take",
  titlePart2: "Your Bigbasket Clone",
  titlePart3: "to the Next Level",
  description: "Enhance your grocery delivery app with Mobility Infotech’s powerful integrations, automation, and growth-focused tools:",
  leftBoxes: [
    {
      text: "10x your Profits",
      desc: "Boost sales and reach through targeted, ROI-driven online marketing campaigns designed for maximum conversions.",
      image: "/assets/home/blink-elearning-1.webp"
    },
    {
      text: "Route Optimization",
      desc: "Assign the shortest, most efficient delivery routes to drivers, reducing delivery time, costs, and fuel usage significantly.",
      image: "/assets/home/blink-elearning-2.webp"
    },
    {
      text: "Advanced Analytics",
      desc: "Gain deep insights into sales, customer behavior, and order trends with powerful real-time analytics dashboards.",
      image: "/assets/home/blink-elearning-3.webp"
    }
  ],
  rightBoxes: [
    {
      text: "Voice Command Orders",
      desc: "Let customers place orders or share instructions easily by recording short, clear audio messages for vendors or agents.",
      image: "/assets/home/blink-elearning-4.webp"
    },
    {
      text: "24/7 In-App Chat Support",
      desc: "Offer instant, round-the-clock assistance to customers through integrated in-app chat for quick query resolution.",
      image: "/assets/home/blink-elearning-5.webp"
    },
    {
      text: "Seamless Integration",
      desc: "Extend your app’s capabilities with limitless third-party API integrations for payments, logistics, CRM, and more.",
      image: "/assets/home/blink-elearning-6.webp"
    }
  ]
}

const forYouData = {
  text: "Run Your Own Bigbasket Like App",
  text2: "",
  title: "Customised To Your Specific-Needs",
  btn: "book free demo",
}

const approachData = {
  titlePart1: "Our Approach –",
  titlePart2: "Fast, Lean, and Scalable",
  description: "At Mobility Infotech, we specialize in MVP development for hyperlocal delivery startups, helping you launch faster, spend smarter, and scale bigger.",

  sliderTitle: "We work in your preferred tech stack",
  sliderImages: ["/assets/home/blink-slide-1.webp", "/assets/home/blink-slide-2.webp", "/assets/home/blink-slide-3.webp", "/assets/home/blink-slide-4.webp", "/assets/home/blink-slide-5.webp", "/assets/home/blink-slide-6.webp", "/assets/home/blink-slide-7.webp", "/assets/home/blink-slide-8.webp", "/assets/home/blink-slide-9.webp",],

  boxes: [
    {
      image: "/assets/home/blinkit-approach-icon-1.webp",
      text: "Get to Market Quicker",
      desc: "Go live early, gather data, and iterate for market fit.",
    },
    {
      image: "/assets/home/blinkit-approach-icon-2.webp",
      text: "Maximise ROI",
      desc: "Budget-friendly MVPs that attract investors and support scaling.",
    },
    {
      image: "/assets/home/blinkit-approach-icon-3.webp",
      text: "Future-proofed Tech",
      desc: "Scalable, innovative solutions that adapt to evolving market demands.",
    },
  ]
}

const marketData = {
  label: "start",
  titlePart1: "Launch your MVP",
  titlePart2: "to market in 8 weeks",
  cta: "get a quote today"
}

const faqData = [
  {
    id: "0",
    question: "01. Can Mobility Infotech develop a grocery delivery app exactly like Bigbasket?",
    answer: "Yes. Mobility Infotech specializes in creating high-performance, Bigbasket-like grocery delivery apps with customizable features, scalable architecture, and a seamless user experience. Our team can replicate the core functionalities of Bigbasket while tailoring the design and features to your unique business needs.",
  },
  {
    id: "1",
    question: "02. How long will it take Mobility Infotech to build my grocery delivery app?",
    answer: "The timeline depends on your requirements. With our MVP-first approach, Mobility Infotech can launch a basic but fully functional grocery delivery app in as little as 4–8 weeks, allowing you to start operations and scale over time.",
  },
  {
    id: "2",
    question: "03. What platforms will my Bigbasket-like app run on?",
    answer: "Mobility Infotech develops cross-platform solutions for Android, iOS, and web browsers. This ensures that your grocery delivery app reaches the widest possible customer base from day one.",
  },
  {
    id: "3",
    question: "04. Will I get an Admin Dashboard, Driver App, and Vendor Panel?",
    answer: "Yes. Our Bigbasket-like solution includes a Customer App, Admin Dashboard, Driver App, and Vendor Panel, each with powerful tools such as real-time tracking, route optimization, inventory management, and sales analytics.",
  },
  {
    id: "4",
    question: "05. How does Mobility Infotech ensure app scalability?",
    answer: "We build with future-proof technology and modular architecture so your app can handle growing user demand, expanding product catalogs, and new integrations without performance issues.",
  },
  {
    id: "5",
    question: "06. Can Mobility Infotech integrate payment gateways and third-party APIs?",
    answer: "Absolutely. Our apps come with secure, multi-mode payment gateways and seamless third-party API integrations for logistics, CRM, marketing, and analytics, giving you unlimited flexibility.",
  },

  {
    id: "6",
    question: "07. Does Mobility Infotech offer marketing support for my grocery app?",
    answer: "Yes. Beyond app development, Mobility Infotech offers ROI-driven marketing campaigns to help you acquire customers faster, increase brand visibility, and boost revenue.",
  },
];

export default function Bigbasket() {
  return (
    <>
      <CabifyBanner data={bannerData} NewClass="blinkit-banner" smallText="Create an Online" />
      <BlinkitBuild data={blinkBuildData} />

      <Suspense fallback={null}>
        <BlinkitFeature data={featureData} />
        <BlaBlaAction data={actionData} label="SHAPE THE FUTURE" />
        <BlinkitElearning data={elearningData} />
        <div className="blink-for-you">
          <BoltForYou data={forYouData} />
        </div>
        <BlinkitApproach data={approachData} />
        <BlinkitMarket data={marketData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
